import { Grow, Modal } from '@mui/material'
import ImageComponent from '../Image';

const Loader = () => {
  return (
    <Modal open={true} aria-labelledby="modal-title" keepMounted>
      <Grow in={true} style={{ transformOrigin: "0 50 50" }} timeout={500}>
        <div
          className="modal fade show"
          id="Terms"
          style={{ display: "block" }}
          aria-modal={true}
        >
          <div className="modalPageCent">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <ImageComponent fileName={'new-coin.gif'} alt='Chola' className="img-fluid coin" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Grow>
    </Modal>
  );
};

export default Loader;
